import React, { useContext, useEffect, useRef, useState } from 'react'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { config } from '@fortawesome/fontawesome-svg-core'
import { faCrosshairs, faEyeSlash, faLayerGroup, faMagnifyingGlass, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import InfiniteScroll from 'react-infinite-scroll-component'
import {
	SortableContext,
	verticalListSortingStrategy,
	arrayMove,
	rectSortingStrategy,
} from "@dnd-kit/sortable";
import DroppableContainer from './DroppableContainer'
import DraggableItem from './DraggableItem'
import { ProductContext } from '../../../../store'
config.autoAddCss = false

const ProductListing = (props) => {
	const divRef = useRef(null),
		[height, setHeight] = useState("100vh"),
		[positionProductId, setPositionProductId] = useState(null),
		[positionValue, setPositionValue] = useState(""),
		[debouncedPosition, setDebouncedPosition] = useState(null),
		[positionChange, setPositionChange] = useState(false),
		[positionTrigger, setPositionTrigger] = useState(false),
		timerRef = useRef(null),
		[hoverProductId, setHoverProductId] = useState(null),
		[actionLoader, setActionLoader] = useState(false),
		[buriedNotAttached, setBuriedNotAttached] = useState([]),
		[showTopButton, setShowTopButton] = useState(false),
		{
			products,
			setProducts,
			productLoader,
			pagePerProducts,
			rowPerProducts,
			productCount,
			shopCurrency,
			hasMore,
			setProductPage,
			productOrder,
			promoted,
			setPromoted,
			buried,
			setBuried,
			hidden,
			setHidden,
			buriedProducts,
			setBuriedProducts,
			hiddenProducts,
			setHiddenProducts,
			loadVisualEditor,
			categoryId,
			debouncedSearch,
			pinnedItems,
			setPinnedItems,
			originalProductOrder,
			pinnedProductIndex,
			setPinnedProductIndex,
			hiddenProductIndex,
			setHiddenProductIndex,
			selectedBanner,
			setSelectedBanner,
			selectedPromoTiles,
			setSelectedPromoTiles,
			dynamicItems,
			setDynamicItems,
		} = useContext(ProductContext)

	useEffect(() => {
		const calculateHeight = () => {
			if (divRef.current) {
				const topPosition = divRef.current.getBoundingClientRect().top
				const newHeight = `calc(100vh - ${topPosition}px)`
				setHeight(newHeight)
			}
		}

		// Calculate height initially
		calculateHeight()

		// Recalculate height on window resize
		window.addEventListener("resize", calculateHeight)
		return () => {
			window.removeEventListener("resize", calculateHeight)
		}
	}, [divRef, loadVisualEditor])

	// Debounce the query input
	useEffect(() => {
		if (positionValue && positionTrigger) {
			setPositionTrigger(false)
			timerRef.current = setTimeout(() => {
				setDebouncedPosition(Number(positionValue));
			}, 2000); // 500ms delay

		}
		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current); // Cleanup on unmount or query change
			}
		}
	}, [positionValue]);

	// useEffect(() => {
	// 	if (debouncedPosition && debouncedPosition <= products.length) {
	// 		setPositionChange(true)
	// 		//if( !dynamicItems.hasOwnProperty(hoverProductId) ){
	// 		let productIndex = productOrder.get(hoverProductId),
	// 			originalProductIndex = originalProductOrder.get(hoverProductId),
	// 			productsLocal = [...products],
	// 			currentProductId = productsLocal[debouncedPosition-1].id,
	// 			promotedLocal = [...promoted],
	// 			pinnedItemsLocal = { ...pinnedItems },
	// 			pinnedProductIndexLocal = { ...pinnedProductIndex },
	// 			buriedLocal = [...buried],
	// 			buriedProductsLocal = [...buriedProducts],
	// 			selectedPromoTilesLocal	= {...selectedPromoTiles},
	// 			dynamicItemsLocal = {...dynamicItems},
	// 			element = productsLocal.splice(productIndex, 1)[0]
			
	// 		if( promotedLocal.indexOf(currentProductId) !== -1 && promotedLocal.indexOf(hoverProductId) !== -1 ){
	// 			if( productIndex < debouncedPosition ){
	// 				for( let i = productIndex; i < debouncedPosition-1; i++ ){
	// 					if( typeof productsLocal[i] !== "undefined" ){
	// 						pinnedItemsLocal[productsLocal[i].id]	= pinnedItemsLocal[productsLocal[i].id] - 1
	// 					}else{
	// 						break;
	// 					}
	// 				}	
	// 			}else{
	// 				for( let i = productIndex-1; i >= debouncedPosition-1; i-- ){
	// 					if( typeof productsLocal[i] !== "undefined" ){
	// 						pinnedItemsLocal[productsLocal[i].id]	= pinnedItemsLocal[productsLocal[i].id] + 1
	// 					}else{
	// 						break;
	// 					}
	// 				}
	// 			}
	// 		}else if (promotedLocal.indexOf(hoverProductId) !== -1 && promotedLocal.length < debouncedPosition) {
	// 			let promotedIndex = promotedLocal.indexOf(hoverProductId)
	// 			promotedLocal.splice(promotedIndex, 1)
	// 			for( let i = productIndex-1; i >= debouncedPosition-1; i-- ){
	// 				if( typeof productsLocal[i] !== "undefined" && promotedLocal.indexOf(productsLocal[i].id.toString()) !== -1 ){
	// 					pinnedItemsLocal[productsLocal[i].id]	= pinnedItemsLocal[productsLocal[i].id] - 1
	// 				}else{
	// 					break;
	// 				}
	// 			}
	// 		} else if (promotedLocal.indexOf(hoverProductId) === -1 && promotedLocal.length >= debouncedPosition) {
	// 			promotedLocal.push(hoverProductId)
	// 			for( let i = debouncedPosition-1; i <= productIndex-1; i++ ){
	// 				if( typeof productsLocal[i] !== "undefined" && promotedLocal.indexOf(productsLocal[i].id.toString()) !== -1 ){
	// 					pinnedItemsLocal[productsLocal[i].id]	= pinnedItemsLocal[productsLocal[i].id] + 1
	// 				}else{
	// 					break;
	// 				}
	// 			}
	// 		}
			
	// 		if( buriedLocal.indexOf(hoverProductId) !== -1 && buriedLocal.indexOf(currentProductId) !== -1 ){
	// 			if( productIndex > debouncedPosition ){
	// 				for( let i = debouncedPosition-1; i < productIndex; i++ ){
	// 					if( typeof productsLocal[i] !== "undefined" ){
	// 						pinnedItemsLocal[productsLocal[i].id]	= pinnedItemsLocal[productsLocal[i].id] + 1
	// 					}else{
	// 						break;
	// 					}
	// 				}	
	// 			}else{
	// 				for( let i = productIndex; i <= debouncedPosition; i++ ){
	// 					if( typeof productsLocal[i] !== "undefined" ){
	// 						pinnedItemsLocal[productsLocal[i].id]	= pinnedItemsLocal[productsLocal[i].id] - 1
	// 					}else{
	// 						break;
	// 					}
	// 				}
	// 			}
	// 		}else if (buriedLocal.indexOf(hoverProductId) !== -1 && ((productCount - buriedLocal.length) >= debouncedPosition)) {
	// 			let buriedIndex = buriedLocal.indexOf(hoverProductId)
	// 			buriedLocal.splice(buriedIndex, 1)
	// 			buriedProductsLocal.splice(buriedIndex, 1)
	// 			for( let i = productIndex-1; i > 0; i-- ){
	// 				if( typeof productsLocal[i] !== "undefined" ){
	// 					let loopProductId = productsLocal[i].id
	// 					if( buriedLocal.indexOf(loopProductId) !== -1 ){
	// 						pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] + 1
	// 					}else{
	// 						break;
	// 					}
	// 				}else{
	// 					break;
	// 				}
	// 			}
	// 		} else if (buriedLocal.indexOf(hoverProductId) === -1 && buriedLocal.length > 0 && ((productCount - buriedLocal.length)) <= debouncedPosition) {
	// 			let newIndex = debouncedPosition - (productCount - buriedLocal.length)
	// 			buriedLocal.splice(newIndex, 0, hoverProductId)
	// 			buriedProductsLocal.splice(newIndex, 0, element)
	// 			for( let i = debouncedPosition -2; i > 0; i-- ){
	// 				if( typeof productsLocal[i] !== "undefined" ){
	// 					let loopProductId = productsLocal[i].id
	// 					if( buriedLocal.indexOf(loopProductId) !== -1 ){
	// 						pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
	// 					}else{
	// 						break;
	// 					}
	// 				}else{
	// 					break;
	// 				}
	// 			}
	// 		}
	// 		let newPositionValue = debouncedPosition - 1
	// 		//if (debouncedPosition > productIndex) {					
	// 		let positionIds	= {...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal},
	// 			sortedKeyArray = Object.entries(positionIds).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
	// 			positionValues = Object.values(positionIds)
	// 		if( positionValues.indexOf(debouncedPosition) !== -1 ){
	// 			let increaseFlag = true;
	// 			for( let i = 0; i < sortedKeyArray.length; i++ ){
	// 				let productId = sortedKeyArray[i]
	// 				if( positionIds[productId] === newPositionValue && increaseFlag ){
	// 					increaseFlag = false;
	// 				}else if( !increaseFlag && ( positionIds[productId] !== newPositionValue  || buriedLocal.indexOf(productId) !== -1 ) ){
	// 					break
	// 				}
	// 				if( increaseFlag ){
	// 					continue;
	// 				}
	// 				if( Object.keys(dynamicItemsLocal).length > 0 && dynamicItemsLocal[productId] >= newPositionValue  ){
	// 					dynamicItemsLocal[productId] = dynamicItemsLocal[productId] + 1
	// 					newPositionValue = newPositionValue + 1
	// 				}else if( typeof pinnedItemsLocal[productId] !== "undefined" && pinnedItemsLocal[productId] >= newPositionValue  ){
	// 					pinnedItemsLocal[productId] = pinnedItemsLocal[productId] + 1
	// 					newPositionValue = newPositionValue + 1
	// 				}else if( typeof selectedPromoTilesLocal[productId] !== "undefined" && selectedPromoTilesLocal[productId] >= newPositionValue  ){
	// 					selectedPromoTilesLocal[productId] = selectedPromoTilesLocal[productId] + 1
	// 					newPositionValue = newPositionValue + 1
	// 				}
	// 			}
	// 		}
	// 		pinnedItemsLocal[hoverProductId] = debouncedPosition - 1
	// 		pinnedProductIndexLocal[hoverProductId] = originalProductIndex
	// 		productsLocal.splice(debouncedPosition - 1, 0, element)
	// 		let newProductIds = { ...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal },
	// 			pinnedProductIds = Object.entries(newProductIds).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
	// 		if( pinnedProductIds.length > 0 ){
	// 			let elements = []
	// 			const idIndexMapLocal = new Map();
	// 			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
	// 			for( let i = 0; i < pinnedProductIds.length; i++ ){
	// 				let currentProductId = pinnedProductIds[i]
	// 				let productIndex = idIndexMapLocal.get(currentProductId)
	// 				let element = productsLocal.splice(productIndex, 1)[0]
	// 				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
	// 				elements.push(element)
	// 			}
	// 			for( let i = 0; i < pinnedProductIds.length; i++ ){
	// 				let element = elements[i]
	// 				let currentProductId = pinnedProductIds[i]
	// 				productsLocal.splice(newProductIds[currentProductId], 0, element)
	// 			}
	// 		}
	// 		setPromoted(promotedLocal)
	// 		setBuriedProducts(buriedProductsLocal)
	// 		setBuried(buriedLocal)
	// 		setSelectedPromoTiles(selectedPromoTilesLocal)
	// 		setPinnedItems(pinnedItemsLocal)
	// 		setPinnedProductIndex(pinnedProductIndexLocal)
	// 		setDynamicItems(dynamicItemsLocal)
	// 		setProducts(productsLocal)
	// 		setPositionValue(null)
	// 		setDebouncedPosition(null)
	// 		setHoverProductId(null)
	// 		setPositionProductId(null)
	// 		setPositionChange(false)
	// 	}
	// }, [debouncedPosition])

	useEffect(() => {
		if (debouncedPosition && debouncedPosition <= products.length) {
			setPositionChange(true)
			let productId = hoverProductId,
				productsLocal = [...products],
				overProductId = productsLocal[debouncedPosition-1].id,
				productIndex = productOrder.get(productId) ?? -1,
				newIndex = productOrder.get(overProductId),
				dynamicItemsLocal = { ...dynamicItems },
				selectedPromoTilesLocal = { ...selectedPromoTiles },
				newElementFlag = false,
				element = productIndex >= 0 ? productsLocal.splice(productIndex, 1)[0] : {}
			if( !dynamicItemsLocal || ( dynamicItemsLocal && Object.keys(dynamicItemsLocal).length === 0 ) ){
				let promotedLocal = [...promoted],
					originalProductIndex = originalProductOrder.get(productId),
					pinnedItemsLocal = { ...pinnedItems },
					pinnedProductIndexLocal = { ...pinnedProductIndex },
					buriedLocal = [...buried],
					buriedProductsLocal = [...buriedProducts],
					pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
					promotedPinned	= {},
					buriedPinned	= {},
					onlyPinnedItemsLocal =  {},
					onlyPinnedValueItems = {},
					pinnedPositions = [],
					pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
					buriedPosition = productsLocal.length;
				Object.keys(pinnedWIthPromoted).forEach((item) => {
					if( promotedLocal.indexOf(item) !== -1 ){
						promotedPinned[item] = pinnedWIthPromoted[item]
					}else if( buriedLocal.indexOf(item) !== -1 ){
						buriedPinned[item] = pinnedWIthPromoted[item]
					}else{
						onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
						if( typeof pinnedItemsLocal[item] !== "undefined" ){
							onlyPinnedValueItems[item] = pinnedItemsLocal[item]
						}
					}
				})
				pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
				if( onlyPinnedValueItems.hasOwnProperty(productId) ){				
					let currentPosition = onlyPinnedValueItems[productId]
					let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					delete onlyPinnedItemsLocal[productId]
					pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
					for( let i = 0; i < sortedKeyArray.length; i++ ){
						let currentProductId = sortedKeyArray[i],
							currentProductPosition = pinnedItemsLocal[currentProductId]
						if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
							let newChangePosition = pinnedItemsLocal[currentProductId] - 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition - 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					let sortedBuriedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					for( let i = 0; i < sortedBuriedKeyArray.length; i++ ){
						let currentProductId = sortedBuriedKeyArray[i],
							currentProductPosition = pinnedItemsLocal[currentProductId]
						if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
							let newChangePosition = pinnedItemsLocal[currentProductId] - 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition - 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					if( promotedLocal.indexOf(overProductId) !== -1 ){
						promotedLocal.push(productId)						
					}else if( buriedLocal.indexOf(overProductId) !== -1 ){
						buriedLocal.push(productId)
						buriedProductsLocal.push(element)
					}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
						let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItems = sortedKeyArray.indexOf(overProductId),
							sortedWithBuried = Object.entries({...onlyPinnedItemsLocal, ...buriedPinned}).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItemsWithBuried = sortedWithBuried.indexOf(overProductId),
							remainingItems = sortedWithBuried.length - currentOnlyPinItemsWithBuried;
						if( productsLocal.length > onlyPinnedItemsLocal[sortedKeyArray[currentOnlyPinItems]] + remainingItems ){
							for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
									break;
								}
							}
						}else{
							for( let i = currentOnlyPinItems; i >= 0; i-- ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] - 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== updateCurrentPosition ){
									break;
								}
							}
						}
					}
					pinnedItemsLocal[productId] = newIndex
				}else if( promotedLocal.indexOf(productId) !== -1 ){
					if( promotedLocal.indexOf(overProductId) !== -1 ){
						let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentPosition = sortedKeyArray.indexOf(productId),
							finalCurrentPosition = sortedKeyArray.indexOf(overProductId)
						if( currentPosition > finalCurrentPosition ){
							for( let i = finalCurrentPosition; i < currentPosition; i++ ){
								if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
									let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition + 1
									}
									pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
								}
							}
						}else{
							for( let i = currentPosition+1; i <= finalCurrentPosition; i++ ){
								if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
									let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition - 1
									}
									pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
								}
							}
						}
					}else {
						let currentPromotedPosition = promotedLocal.indexOf(productId)
						promotedLocal.splice(currentPromotedPosition, 1)
						let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentPosition = sortedKeyArray.indexOf(productId)
						for( let i = 0; i < sortedKeyArray.length; i++ ){
							if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
								let currentProductPosition = pinnedItemsLocal[sortedKeyArray[i]]
								if( productIndex < newIndex && productIndex <= currentProductPosition ){
									let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition - 1
									}
									pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
								}else if(newIndex < productIndex && currentProductPosition > newIndex && currentProductPosition <= productIndex){
									let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition + 1
									}
									pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
								}
							}
						}
						if( buriedLocal.indexOf(overProductId) !== -1 ){
							buriedLocal.push(productId)
							buriedProductsLocal.push(element)
							let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
								currentPosition = sortedKeyArray.indexOf(overProductId)
							for( let i = 0; i < currentPosition+1; i++ ){
								let currentProductId = sortedKeyArray[i]
								if( typeof pinnedItemsLocal[currentProductId] !== "undefined" ){
									let newChangePosition = pinnedItemsLocal[currentProductId] - 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition - 1
									}
									pinnedItemsLocal[currentProductId] = newChangePosition
								}
							}
						}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
							let sortedBuriedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
							for( let i = 0; i < sortedBuriedKeyArray.length; i++ ){
								let currentProductId = sortedBuriedKeyArray[i],
									currentProductPosition = pinnedItemsLocal[currentProductId]
								if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
									let newChangePosition = pinnedItemsLocal[currentProductId] - 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition - 1
									}
									pinnedItemsLocal[currentProductId] = newChangePosition
								}
							}
							let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
								currentOnlyPinItems = sortedKeyArray.indexOf(overProductId),
								sortedWithBuried = Object.entries({...onlyPinnedItemsLocal, ...buriedPinned}).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
								currentOnlyPinItemsWithBuried = sortedWithBuried.indexOf(overProductId),
								remainingItems = sortedWithBuried.length - currentOnlyPinItemsWithBuried;
							if( productsLocal.length > onlyPinnedItemsLocal[sortedKeyArray[currentOnlyPinItems]] + remainingItems ){
								for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
									let currentProductId = sortedKeyArray[i],
										updateCurrentPosition = 0;
									if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
										updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
										selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
									}else{
										updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
										pinnedItemsLocal[currentProductId] = updateCurrentPosition
									}
									if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
										break;
									}
								}
							}else{
								for( let i = currentOnlyPinItems; i >= 0; i-- ){
									let currentProductId = sortedKeyArray[i],
										updateCurrentPosition = 0;
									if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
										updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
										selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
									}else{
										updateCurrentPosition = pinnedItemsLocal[currentProductId] - 1
										pinnedItemsLocal[currentProductId] = updateCurrentPosition
									}
									if( typeof onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== updateCurrentPosition ){
										break;
									}
								}
							}
						}
					}
					pinnedItemsLocal[productId] = newIndex
				}else if( buriedLocal.indexOf(productId) !== -1 ){
					if( buriedLocal.indexOf(overProductId) !== -1 ){
						let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentPosition = sortedKeyArray.indexOf(productId),
							finalCurrentPosition = sortedKeyArray.indexOf(overProductId)
						if( currentPosition > finalCurrentPosition ){
							for( let i = finalCurrentPosition; i < currentPosition; i++ ){
								if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
									let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition + 1
									}
									pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
								}
							}
						}else{
							for( let i = currentPosition+1; i <= finalCurrentPosition; i++ ){
								if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
									let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition - 1
									}
									pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
								}
							}
						}
					}else{
						let currentBuriedPosition = buriedLocal.indexOf(productId)
						buriedLocal.splice(currentBuriedPosition, 1)
						buriedProductsLocal.splice(currentBuriedPosition, 1)
						let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentPosition = sortedKeyArray.indexOf(productId)

						for( let i = currentPosition; i >= 0; i-- ){
							let currentProductId = sortedKeyArray[i]
							if( typeof pinnedItemsLocal[currentProductId] !== "undefined" && pinnedItemsLocal[currentProductId] > newIndex ){
								let newChangePosition = pinnedItemsLocal[currentProductId] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}
						}
						if( promotedLocal.indexOf(overProductId) !== -1 ){
							promotedLocal.push(productId)
							let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
								currentPosition = sortedKeyArray.indexOf(overProductId)
							for( let i = currentPosition; i < sortedKeyArray.length; i++ ){
								let currentProductId = sortedKeyArray[i]
								if( typeof pinnedItemsLocal[currentProductId] !== "undefined" ){
									let newChangePosition = pinnedItemsLocal[currentProductId] + 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition + 1
									}
									pinnedItemsLocal[currentProductId] = newChangePosition
								}
							}
						}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
							let sortedPromotedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
							for( let i = 0; i < sortedPromotedKeyArray.length; i++ ){
								let currentProductId = sortedPromotedKeyArray[i],
									currentProductPosition = pinnedItemsLocal[currentProductId]
								if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
									let newChangePosition = pinnedItemsLocal[currentProductId] + 1
									while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
										newChangePosition = newChangePosition + 1
									}
									pinnedItemsLocal[currentProductId] = newChangePosition
								}
							}
							let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
								currentOnlyPinItems = sortedKeyArray.indexOf(overProductId)
							for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
									break;
								}
							}
						}
					}
					pinnedItemsLocal[productId] = newIndex
				}else if( !pinnedWIthPromoted.hasOwnProperty(productId) ){
					if( !pinnedWIthPromoted.hasOwnProperty(overProductId) ){
						pinnedItemsLocal[productId] = newIndex
					}else{
						let currentPosition = productOrder.get(productId)
						let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
						pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
						for( let i = 0; i < sortedKeyArray.length; i++ ){
							let currentProductId = sortedKeyArray[i],
								currentProductPosition = pinnedItemsLocal[currentProductId]
							if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
								let newChangePosition = pinnedItemsLocal[currentProductId] - 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition - 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
								let newChangePosition = pinnedItemsLocal[currentProductId] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}
						}
						let sortedBuriedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
						for( let i = 0; i < sortedBuriedKeyArray.length; i++ ){
							let currentProductId = sortedBuriedKeyArray[i],
								currentProductPosition = pinnedItemsLocal[currentProductId]
							if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
								let newChangePosition = pinnedItemsLocal[currentProductId] - 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition - 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
								let newChangePosition = pinnedItemsLocal[currentProductId] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}
						}
						if( promotedLocal.indexOf(overProductId) !== -1 ){
							promotedLocal.push(productId)						
						}else if( buriedLocal.indexOf(overProductId) !== -1 ){
							buriedLocal.push(productId)
							buriedProductsLocal.push(element)
						}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
							let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
								currentOnlyPinItems = sortedKeyArray.indexOf(overProductId),
								sortedWithBuried = Object.entries({...onlyPinnedItemsLocal, ...buriedPinned}).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
								currentOnlyPinItemsWithBuried = sortedWithBuried.indexOf(overProductId),
								remainingItems = sortedWithBuried.length - currentOnlyPinItemsWithBuried;
							if( productsLocal.length > onlyPinnedItemsLocal[sortedKeyArray[currentOnlyPinItems]] + remainingItems ){
								for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
									let currentProductId = sortedKeyArray[i],
										updateCurrentPosition = 0;
									if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
										updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
										selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
									}else{
										updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
										pinnedItemsLocal[currentProductId] = updateCurrentPosition
									}
									if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
										break;
									}
								}
							}else{
								for( let i = currentOnlyPinItems; i >= 0; i-- ){
									let currentProductId = sortedKeyArray[i],
										updateCurrentPosition = 0;
									if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
										updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
										selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
									}else{
										updateCurrentPosition = pinnedItemsLocal[currentProductId] - 1
										pinnedItemsLocal[currentProductId] = updateCurrentPosition
									}
									if( typeof onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== updateCurrentPosition ){
										break;
									}
								}
							}
						}
						pinnedItemsLocal[productId] = newIndex
					}
				}
				productsLocal.splice(newIndex, 0, element)
				let positionIds = { ...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal },
					pinnedProductIds = Object.entries(positionIds).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
				if (pinnedProductIds.length > 0) {
					const idIndexMapLocal = new Map();
					let elements = []
					productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
					for( let i = 0; i < pinnedProductIds.length; i++ ){
						let currentProductId = pinnedProductIds[i]
						let productIndex = idIndexMapLocal.get(currentProductId)
						let element = productsLocal.splice(productIndex, 1)[0]
						productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
						elements.push(element)
					}
					for( let i = 0; i < pinnedProductIds.length; i++ ){
						let element = elements[i]
						let currentProductId = pinnedProductIds[i]
						productsLocal.splice(positionIds[currentProductId], 0, element)
					}
				}
				setPromoted(promotedLocal)
				setBuriedProducts(buriedProductsLocal)
				setBuried(buriedLocal)
				setSelectedPromoTiles(selectedPromoTilesLocal)
				setPinnedItems(pinnedItemsLocal)
				setPinnedProductIndex(pinnedProductIndexLocal)
				setDynamicItems(dynamicItemsLocal)
				setProducts(productsLocal)
			}else{
				let dynamicWithPromoted = {...dynamicItemsLocal, ...selectedPromoTilesLocal}
				let sortedKeyArray = Object.entries(dynamicWithPromoted).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
					currentDynamicItems = sortedKeyArray.indexOf(overProductId)
				if( productIndex === -1 ){
					for( let i = currentDynamicItems; i < sortedKeyArray.length; i++ ){
						let currentProductId = sortedKeyArray[i],
							updateCurrentPosition = 0;
						if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
							updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
							selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
						}else{
							updateCurrentPosition = dynamicItemsLocal[currentProductId] + 1
							dynamicItemsLocal[currentProductId] = updateCurrentPosition
						}
						if( typeof dynamicWithPromoted[sortedKeyArray[i+1]] !== "undefined" && dynamicWithPromoted[sortedKeyArray[i+1]] !== updateCurrentPosition ){
							break;
						}
					}
				}else if( currentDynamicItems < productIndex ){
					for( let i = currentDynamicItems; i < sortedKeyArray.length; i++ ){
						let currentProductId = sortedKeyArray[i],
							updateCurrentPosition = 0;
						if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
							updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
							selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
						}else{
							updateCurrentPosition = dynamicItemsLocal[currentProductId] + 1
							dynamicItemsLocal[currentProductId] = updateCurrentPosition
						}
						if( typeof dynamicWithPromoted[sortedKeyArray[i+1]] !== "undefined" && dynamicWithPromoted[sortedKeyArray[i+1]] !== updateCurrentPosition ){
							break;
						}
					}
				}else{
					for( let i = currentDynamicItems; i > productIndex; i-- ){
						let currentProductId = sortedKeyArray[i],
							updateCurrentPosition = 0;
						if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
							updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
							selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
						}else{
							updateCurrentPosition = dynamicItemsLocal[currentProductId] - 1
							dynamicItemsLocal[currentProductId] = updateCurrentPosition
						}
					}
				}
				dynamicItemsLocal[productId]	= newIndex
				productsLocal.splice(newIndex, 0, element)
				setSelectedPromoTiles(selectedPromoTilesLocal)
				setDynamicItems(dynamicItemsLocal)
				setProducts(productsLocal)
			}
			setPositionChange(false)
			setPositionValue(null)
			setDebouncedPosition(null)
			setHoverProductId(null)
			setPositionProductId(null)
		}		
	}, [debouncedPosition])

	useEffect(() => {
		if (!hasMore && buriedNotAttached.length > 0) {
			let buriedNotAttachedLocal = [...buriedNotAttached],
				productsLocal = [...products]
			for (let i = 0; i < buriedNotAttachedLocal.length; i++) {
				let currentBuriedNotAttached = buriedNotAttachedLocal[i]
				productsLocal.push(currentBuriedNotAttached)
			}
			setProducts(productsLocal)
			setBuriedNotAttached([])
		}
	}, [hasMore, buriedNotAttached])

	useEffect(() => {
		console.log({...pinnedItems, ...selectedPromoTiles}, "Pinned Items")
	}, [pinnedItems, selectedPromoTiles])

	const chunkProducts = (arr, chunkSize) => {
		const chunks = [];
		for (let i = 0; i < arr.length; i += chunkSize) {
			chunks.push(arr.slice(i, i + chunkSize));
		}
		return chunks;
	}

	const getPriceRange = (product) => {
		let min = product.price,
			max = product.price;
		if (typeof product.variants !== "undefined" && product.variants.length > 0) {
			min = product.variants[0].calculated_price > 0 ? product.variants[0].calculated_price : (product.variants[0].sale_price > 0 ? product.variants[0].sale_price : product.variants[0].price)
			max = min
			for (let i = 0; i < product.variants.length; i++) {
				let currentVariant = product.variants[i]
				if (currentVariant.calculated_price > 0) {
					if (min > currentVariant.calculated_price) {
						min = currentVariant.calculated_price
					} else if (max < currentVariant.calculated_price) {
						max = currentVariant.calculated_price
					}
				} else if (currentVariant.sale_price > 0) {
					if (min > currentVariant.sale_price) {
						min = currentVariant.sale_price
					} else if (max < currentVariant.sale_price) {
						max = currentVariant.sale_price
					}
				} else if (currentVariant.price > 0) {
					if (min > currentVariant.price) {
						min = currentVariant.price
					} else if (max < currentVariant.price) {
						max = currentVariant.price
					}
				}
			}
		}
		return { min, max }
	}

	const formPriceText = (price) => {
		let priceAmt = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: shopCurrency,
		}).format(price);
		return priceAmt
	}

	const formatPrice = (product) => {
		let { min, max } = getPriceRange(product)
		if (min === max) {
			if (product.sale_price > 0) {
				return <><span className="cbPriceList">{formPriceText(product.sale_price)}</span><span className="cbPriceList cbOriginalPrice">{formPriceText(product.price)}</span></>
			} else {
				return <span className="cbPriceList">{formPriceText(product.price)}</span>
			}
		} else {
			let minPrice = formPriceText(min),
				maxPrice = formPriceText(max);
			return <span className="cbPriceList">{minPrice} - {maxPrice}</span>
		}
	}

	const productMouseOver = (producId) => {
		if (hoverProductId !== producId) {
			setHoverProductId(producId)
			setPositionProductId(null)
		}
	}

	const promptProduct = (productId) => {
		setActionLoader(true)
		let promotedLocal = [...promoted],
			pinnedItemsLocal = { ...pinnedItems },
			buriedLocal = [...buried],
			dynamicItemsLocal = {...dynamicItems},
			buriedProductsLocal = [...buriedProducts],
			productIndex = productOrder.get(productId) ?? -1,
			productsLocal = [...products],
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			element = productIndex >= 0 ? productsLocal.splice(productIndex, 1)[0] : {},
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
			promotedPosition = 0;
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if(productIndex === -1){
			return
		}
		while( pinnedPositions.indexOf(promotedPosition) !== -1 ){
			promotedPosition = promotedPosition + 1
		}
		if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
			delete onlyPinnedItemsLocal[productId]
			delete pinnedItemsLocal[productId]
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		if (buriedLocal.indexOf(productId) !== -1) {
			let buriedIndex = buriedLocal.indexOf(productId)
			buriedLocal.splice(buriedIndex, 1)
			buriedProductsLocal.splice(buriedIndex, 1)
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentBuriedPosition = sortedKeyArray.indexOf(productId)
			for( let i = 0; i < currentBuriedPosition; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete buriedPinned[productId]
		}
		if (promotedLocal.indexOf(productId) === -1) {
			for( let i = 0; i < promotedLocal.length; i++ ){
				if( typeof pinnedItemsLocal[promotedLocal[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[promotedLocal[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[promotedLocal[i]] = newChangePosition
				}
			}
			promotedLocal.push(productId)
		}else if( promotedLocal.indexOf(productId) !== -1 ){
			let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentPromotedPosition = sortedKeyArray.indexOf(productId)
			for( let i = 0; i < currentPromotedPosition; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition + 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
		}
		productsLocal.splice(promotedPosition, 0, element)
		pinnedItemsLocal[productId] = promotedPosition
		if (typeof pinnedProductIndex[productId] === "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			pinnedProductIndexLocal[productId] = originalProductOrder.get(productId)
			setPinnedProductIndex(pinnedProductIndexLocal)
		}
		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				let element = productsLocal.splice(productIndex, 1)[0]
				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
				elements.push(element)
			}
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let element = elements[i]
				let currentProductId = pinnedProductIds[i]
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setBuriedProducts(buriedProductsLocal)
		setBuried(buriedLocal)
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setPromoted(promotedLocal)
		setProducts(productsLocal)
		setDynamicItems(dynamicItemsLocal)
		setActionLoader(false)
	}

	const buriedProduct = (productId) => {
		setActionLoader(true)
		let buriedLocal = [...buried],
			promotedLocal = [...promoted],
			pinnedItemsLocal = { ...pinnedItems },
			dynamicItemsLocal = {...dynamicItems},
			buriedProductsLocal = [...buriedProducts],
			productIndex = productOrder.get(productId) ?? -1,
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			buriedNotAttachedLocal = [...buriedNotAttached],
			pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			productsLocal = [...products],
			element = productIndex >= 0 ? productsLocal.splice(productIndex, 1)[0] : {},
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
			buriedPosition = productsLocal.length;
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if(productIndex === -1){
			return
		}
		while( pinnedPositions.indexOf(buriedPosition) !== -1 ){
			buriedPosition = buriedPosition - 1
		}
		if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
			delete onlyPinnedItemsLocal[productId]
			delete pinnedItemsLocal[productId]
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		if (promotedLocal.indexOf(productId) !== -1) {
			let promotedIndex = promotedLocal.indexOf(productId)
			promotedLocal.splice(promotedIndex, 1)
			let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentPromotedPosition = sortedKeyArray.indexOf(productId)
			for( let i = currentPromotedPosition+1; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete promotedPinned[productId]
			// for( let i = productIndex; i < productsLocal.length; i++ ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( promotedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		}
		if (buriedLocal.indexOf(productId) === -1) {
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			for( let i = 0; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			buriedLocal.push(productId)
			buriedProductsLocal.push(element)
			// for( let i = productsLocal.length-1; i >= 0; i-- ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( buriedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		} else if (buriedLocal.indexOf(productId) !== -1) {
			let buriedIndex = buriedLocal.indexOf(productId),
				buriedProductId = buriedLocal.splice(buriedIndex, 1)[0],
				burriedProduct = buriedProductsLocal.splice(buriedIndex, 1)[0]
			buriedLocal.splice(buriedLocal.length, 0, buriedProductId)
			buriedProductsLocal.splice(buriedProductsLocal.length, 0, burriedProduct)
			let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			let currentBuriedPosition = sortedKeyArray.indexOf(productId)
			for( let i = currentBuriedPosition+1; i < sortedKeyArray.length; i++ ){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
				}
			}
			delete buriedPinned[productId]
			// for( let i = productIndex; i < productsLocal.length; i++ ){
			// 	if( typeof productsLocal[i] !== "undefined" ){
			// 		let loopProductId = productsLocal[i].id
			// 		if( buriedLocal.indexOf(loopProductId) !== -1 ){
			// 			pinnedItemsLocal[loopProductId]	= pinnedItemsLocal[loopProductId] - 1
			// 		}else{
			// 			break;
			// 		}
			// 	}else{
			// 		break;
			// 	}
			// }
		}
		if ( buriedPosition <= productsLocal.length ) {
			productsLocal.splice(buriedPosition, 0, element)
		} else {
			buriedNotAttachedLocal.push(element)
		}
		pinnedItemsLocal[productId] = buriedPosition
		if (typeof pinnedProductIndex[productId] === "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			pinnedProductIndexLocal[productId] = originalProductOrder.get(productId)
			setPinnedProductIndex(pinnedProductIndexLocal)
		}

		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				if( typeof productIndex !== "undefined" ){
					let element = productsLocal.splice(productIndex, 1)[0]
					productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
					elements.push(element)
				}
			}
			for( let i = 0; i < elements.length; i++ ){
				let element = elements[i]
				let currentProductId = element.id
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setPromoted(promotedLocal)
		setBuriedNotAttached(buriedNotAttachedLocal)
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setBuried(buriedLocal)
		setBuriedProducts(buriedProductsLocal)
		setProducts(productsLocal)
		setDynamicItems(dynamicItemsLocal)
		setActionLoader(false)
	}

	const hiddenProduct = (productId) => {
		setActionLoader(true)
		let hiddenLocal = [...hidden],
			hiddenProductsLocal = [...hiddenProducts],
			pinnedItemsLocal = { ...pinnedItems },
			buriedLocal = [...buried],
			promotedLocal = [...promoted],
			buriedProductsLocal = [...buriedProducts],
			productIndex = productOrder.get(productId) ?? -1,
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			originalProductIndex = originalProductOrder.get(productId),
			productsLocal = [...products],
			element = productIndex >= 0 ? productsLocal.splice(productIndex, 1)[0] : {},
			pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if(productIndex === -1){
			return
		}
		if (hiddenLocal.indexOf(productId) === -1) {
			hiddenLocal.push(productId)
			hiddenProductsLocal.push(element)
		}else{
			return
		}
		if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
			delete onlyPinnedItemsLocal[productId]
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		let sortedKeyArray = Object.entries(pinnedWIthPromoted).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
			currentPosition = sortedKeyArray.indexOf(productId),
			sortedPinnedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
		for( let i = 0; i < sortedKeyArray.length; i++ ){
			let currentProductId = sortedKeyArray[i],
				currentProductPosition = pinnedWIthPromoted[currentProductId],
				pinnedKeyIndex = sortedPinnedKeyArray ? sortedPinnedKeyArray.indexOf(currentProductId) : -1
			if( currentProductPosition > productIndex){
				if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" && ( typeof onlyPinnedItemsLocal[sortedKeyArray[i]] === "undefined" ) ){
					let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
					while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
						newChangePosition = newChangePosition - 1
					}
					pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
					if( onlyPinnedItemsLocal[sortedKeyArray[i]] ){
						onlyPinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
					}
				}else if( pinnedKeyIndex !== -1 ){
					let remainingPinnedItems = ( sortedPinnedKeyArray.length - pinnedKeyIndex )
					let additionalPosition = remainingPinnedItems + pinnedItemsLocal[currentProductId]
					if( additionalPosition + 1 > productsLocal.length ){
						let newChangePosition = pinnedItemsLocal[currentProductId] - 1
						pinnedItemsLocal[currentProductId] = newChangePosition
						if( onlyPinnedItemsLocal[currentProductId] ){
							onlyPinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
				}
			}
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
			delete onlyPinnedItemsLocal[productId]
			delete pinnedItemsLocal[productId]
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		}
		if( promotedLocal.indexOf(productId) !== -1 ){
			promotedLocal.splice(promotedLocal.indexOf(productId), 1)
		}else if( buriedLocal.indexOf(productId) !== -1 ){
			buriedLocal.splice(buriedLocal.indexOf(productId), 1)
		}
		if (typeof pinnedItemsLocal[productId] !== "undefined") {
			delete pinnedItemsLocal[productId]
		}
		if (typeof pinnedProductIndex[productId] !== "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			delete pinnedProductIndexLocal[productId]
			setPinnedProductIndex(pinnedProductIndexLocal)
		}
		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				let element = productsLocal.splice(productIndex, 1)[0]
				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
				elements.push(element)
			}
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let element = elements[i]
				let currentProductId = pinnedProductIds[i]
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setPromoted(promotedLocal)
		setBuried(buriedLocal)
		setBuriedProducts(buriedProductsLocal)
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setHidden(hiddenLocal)
		setHiddenProducts(hiddenProductsLocal)
		setProducts(productsLocal)
		setHiddenProductIndex({
			...hiddenProductIndex,
			[element.id]: originalProductIndex
		})
		setActionLoader(false)
	}

	const pinProduct = (productId) => {
		let pinnedItemsLocal = { ...pinnedItems },
			productIndex = productOrder.get(productId)
		pinnedItemsLocal[productId] = productIndex
		if (typeof pinnedProductIndex[productId] === "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			pinnedProductIndexLocal[productId] = originalProductOrder.get(productId)
			setPinnedProductIndex(pinnedProductIndexLocal)
		}
		setPinnedItems(pinnedItemsLocal)
	}

	const restoreProduct = (productId) => {
		if( positionProductId === productId ){
			return
		}
		let pinnedItemsLocal = { ...pinnedItems },
			buriedLocal = [...buried],
			buriedProductsLocal = [...buriedProducts],
			promotedLocal = [...promoted],
			hiddenLocal = [...hidden],
			productIndex = productOrder.get(productId) ?? -1,
			newProductIndex = originalProductOrder.get(productId),
			selectedPromoTilesLocal	= {...selectedPromoTiles},
			pinnedWIthPromoted = { ...pinnedItemsLocal, ...selectedPromoTilesLocal },
			productsLocal = [...products],
			element = {},
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
			buriedPosition = productsLocal.length;
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if (promotedLocal.indexOf(productId) !== -1) {
			promotedLocal.splice(promotedLocal.indexOf(productId), 1)
			for( let i = 0; i < promotedLocal.length; i++ ){
				if( pinnedItemsLocal[promotedLocal[i]] > productIndex ){
					pinnedItemsLocal[promotedLocal[i]]	= pinnedItemsLocal[promotedLocal[i]] - 1
				}
			}
		}
		if (buriedLocal.indexOf(productId) !== -1) {
			let buriedProductIndex = buriedLocal.indexOf(productId)
			buriedLocal.splice(buriedProductIndex, 1)
			buriedProductsLocal.splice(buriedProductIndex, 1)
			for( let i = 0; i < buriedLocal.length; i++ ){
				if( pinnedItemsLocal[buriedLocal[i]] > productIndex ){
					pinnedItemsLocal[buriedLocal[i]]	= pinnedItemsLocal[buriedLocal[i]] - 1
				}
			}
		}
		let lowerIndexCount = 0, //Object.values(hiddenProductIndex).filter(index => index < newProductIndex).length,
			newLowerIndexCount = 0, //Object.values(pinnedProductIndex).filter(index => index > newProductIndex).length,
			newLowerIndexCount2	= Object.values(selectedPromoTilesLocal).filter(index => index < newProductIndex).length,
			newLowerIndexCount3	= 0
		for( let i = 0; i < hiddenLocal.length; i++ ){
			let currentHiddenProductId = hiddenLocal[i],
				currentHiddenProductIndex	= originalProductOrder.get(currentHiddenProductId)
			if( currentHiddenProductIndex < newProductIndex ){
				lowerIndexCount++
			}
		}
		for (const key in pinnedItemsLocal) {
			if( key === productId ) continue;
			let currentPinnedProductId = key,
				currentPinnedProductIndex = originalProductOrder.get(currentPinnedProductId)
			if( currentPinnedProductIndex > newProductIndex && pinnedItemsLocal[key] < newProductIndex ){
				newLowerIndexCount2++
			}else if( currentPinnedProductIndex < newProductIndex && pinnedItemsLocal[key] > newProductIndex ){
				newLowerIndexCount3++
			}
		}
		newProductIndex = ( newProductIndex + newLowerIndexCount2 + newLowerIndexCount ) - lowerIndexCount - newLowerIndexCount3;
		
		if( Object.values(buriedPinned).length > 0 ){
			let sortedValueArray = Object.values(buriedPinned).sort((a, b) => Number(a) - Number(b))
			if( sortedValueArray.length > 0 && sortedValueArray[0] < newProductIndex ){				
				let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
				for( let i = 0; i < sortedKeyArray.length; i++ ){
					let currentProductId = sortedKeyArray[i]
					if( productIndex > sortedValueArray[sortedValueArray.length - 1] ){
						if( typeof pinnedItemsLocal[currentProductId] !== "undefined"){
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}else if( productIndex < sortedValueArray[0] && productIndex > pinnedItemsLocal[currentProductId] ){
						let newChangePosition = pinnedItemsLocal[currentProductId] + 1
						while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
							newChangePosition = newChangePosition + 1
						}
						pinnedItemsLocal[currentProductId] = newChangePosition
					}
				}
				newProductIndex = sortedValueArray[0]
			}
		}
		element = productsLocal.splice(productIndex, 1)[0]
		if (newProductIndex < promotedLocal.length) {
			newProductIndex = promotedLocal.length
		}
		productsLocal.splice(newProductIndex, 0, element)
		if (typeof pinnedItemsLocal[parseInt(productId)] !== "undefined") {
			delete pinnedItemsLocal[parseInt(productId)]
		}
		// let burriedProductIds = buriedProductsLocal.map((product) => product.id).reverse()
		// for (let i = 0; i < burriedProductIds.length; i++) {
		// 	pinnedItemsLocal[burriedProductIds[i]] = (productCount - hidden.length) - i
		// }
		if (typeof pinnedProductIndex[productId] !== "undefined") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex }
			delete pinnedProductIndexLocal[productId]
		}
		let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal},
			pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
		if (pinnedProductIds.length > 0) {
			// const idIndexMapLocal = new Map();
			// productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			// for (let i = 0; i < pinnedProductIds.length; i++) {
			// 	let currentProductId = pinnedProductIds[i],
			// 		pinnedIndex = Number(positionIdsNew[currentProductId]),
			// 		productIndex = idIndexMapLocal.get(currentProductId);
			// 	if (typeof productIndex === "undefined" || productIndex === pinnedIndex) continue;
			// 	let element = productsLocal.splice(productIndex, 1)[0];
			// 	productsLocal.splice(pinnedIndex, 0, element);
			// 	if (productIndex < pinnedIndex) {
			// 		for (let j = productIndex; j < pinnedIndex - 1; j++) {
			// 			if (productsLocal[j]) {
			// 				let id = productsLocal[j].id;
			// 				idIndexMapLocal.set(id, j);
			// 			}
			// 		}
			// 	} else {
			// 		for (let j = pinnedIndex; j <= productIndex; j++) {
			// 			if (productsLocal[j]) {
			// 				let id = productsLocal[j].id;
			// 				idIndexMapLocal.set(id, j);
			// 			}
			// 		}
			// 	}
			// 	idIndexMapLocal.set(currentProductId, pinnedIndex - 1);
			// }
			const idIndexMapLocal = new Map();
			let elements = []
			productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let currentProductId = pinnedProductIds[i]
				let productIndex = idIndexMapLocal.get(currentProductId)
				let element = productsLocal.splice(productIndex, 1)[0]
				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
				elements.push(element)
			}
			for( let i = 0; i < pinnedProductIds.length; i++ ){
				let element = elements[i]
				let currentProductId = pinnedProductIds[i]
				productsLocal.splice(positionIdsNew[currentProductId], 0, element)
			}
		}
		setPromoted(promotedLocal)
		setBuried(buriedLocal)
		setBuriedProducts(buriedProductsLocal)
		setSelectedPromoTiles(selectedPromoTilesLocal)
		setPinnedItems(pinnedItemsLocal)
		setProducts(productsLocal)
	}

	const handleScroll = (e) => {
		setShowTopButton(e.target.scrollTop > 600);
	}

	const scrollToTop = () => {
		const scrollableDiv = document.getElementById("visualEditorGridContainer");
		scrollableDiv.scrollTo({ top: 0, behavior: "smooth" });
	}

	const deletePromoTile = (prodIndex, productId) => {
		setActionLoader(true)
		let selectedPromoTilesLocal	= {...selectedPromoTiles},
			pinnedItemsLocal = { ...pinnedItems },
			buriedLocal = [...buried],
			promotedLocal = [...promoted],
			dynamicItemsLocal = { ...dynamicItems },
			productIndex = productOrder.get(productId) ?? -1,
			productsLocal = [...products],
			element = productIndex >= 0 ? productsLocal.splice(productIndex, 1)[0] : {},
			pinnedWIthPromoted = { ...pinnedItemsLocal, ...selectedPromoTilesLocal },
			promotedPinned	= {},
			buriedPinned	= {},
			onlyPinnedItemsLocal =  {},
			pinnedPositions = [],
			pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null
		Object.keys(pinnedWIthPromoted).forEach((item) => {
			if( promotedLocal.indexOf(item) !== -1 ){
				promotedPinned[item] = pinnedWIthPromoted[item]
			}else if( buriedLocal.indexOf(item) !== -1 ){
				buriedPinned[item] = pinnedWIthPromoted[item]
			}else{
				onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
			}
		})
		pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
		if(productIndex === -1){
			return
		}
		if( !dynamicItemsLocal || ( dynamicItemsLocal && Object.keys(dynamicItemsLocal).length === 0 ) ){
			if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
				delete onlyPinnedItemsLocal[productId]
				pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
			}
			let sortedKeyArray = Object.entries(pinnedWIthPromoted).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
				currentPosition = sortedKeyArray.indexOf(productId),
				sortedPinnedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			for( let i = 0; i < sortedKeyArray.length; i++ ){
				let currentProductId = sortedKeyArray[i],
					currentProductPosition = pinnedWIthPromoted[currentProductId],
					pinnedKeyIndex = sortedPinnedKeyArray ? sortedPinnedKeyArray.indexOf(currentProductId) : -1
				if( currentProductPosition > productIndex){
					if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" && ( typeof onlyPinnedItemsLocal[sortedKeyArray[i]] === "undefined" ) ){
						let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
						while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
							newChangePosition = newChangePosition - 1
						}
						pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
						if( onlyPinnedItemsLocal[sortedKeyArray[i]] ){
							onlyPinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
						}
					}else if( pinnedKeyIndex !== -1 ){
						let remainingPinnedItems = ( sortedPinnedKeyArray.length - pinnedKeyIndex )
						let additionalPosition = remainingPinnedItems + pinnedItemsLocal[currentProductId]
						if( additionalPosition + 1 > productsLocal.length ){
							let newChangePosition = pinnedItemsLocal[currentProductId] - 1
							pinnedItemsLocal[currentProductId] = newChangePosition
							if( onlyPinnedItemsLocal[currentProductId] ){
								onlyPinnedItemsLocal[currentProductId] = newChangePosition
							}
						}
					}
				}
				pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
			}
			if( typeof onlyPinnedItemsLocal[productId] !== "undefined" ){
				delete onlyPinnedItemsLocal[productId]
				delete pinnedItemsLocal[productId]
				pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
			}
			if( typeof selectedPromoTilesLocal[productId] ){
				delete selectedPromoTilesLocal[productId]
			}
			let positionIdsNew	= {...pinnedItemsLocal, ...selectedPromoTilesLocal},
				pinnedProductIds = Object.entries(positionIdsNew).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key);
			if (pinnedProductIds.length > 0) {
				const idIndexMapLocal = new Map();
				let elements = []
				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
				for( let i = 0; i < pinnedProductIds.length; i++ ){
					let currentProductId = pinnedProductIds[i]
					let productIndex = idIndexMapLocal.get(currentProductId)
					let element = productsLocal.splice(productIndex, 1)[0]
					productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
					elements.push(element)
				}
				for( let i = 0; i < pinnedProductIds.length; i++ ){
					let element = elements[i]
					let currentProductId = pinnedProductIds[i]
					productsLocal.splice(positionIdsNew[currentProductId], 0, element)
				}
			}
			setSelectedPromoTiles(selectedPromoTilesLocal)
			setPinnedItems(pinnedItemsLocal)			
			setProducts(productsLocal)
			setActionLoader(false)
		}else{
			if( typeof selectedPromoTilesLocal[productId] === "undefined" ){
				return
			}
			let dynamicItemsLocal = { ...dynamicItems },
				dynamicWithPromoted = { ...dynamicItemsLocal, ...selectedPromoTilesLocal }
			let sortedKeyArray = Object.entries(dynamicWithPromoted).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			for( let i = 0; i < sortedKeyArray.length; i++ ){
				let currentProductId = sortedKeyArray[i]
				let currentProductPosition = dynamicWithPromoted[currentProductId]
				if( currentProductPosition > productIndex ){
					let newChangePosition = currentProductPosition - 1
					if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
						selectedPromoTilesLocal[currentProductId] = newChangePosition
					}else{
						dynamicItemsLocal[currentProductId] = newChangePosition
					}
				}
			}
			setDynamicItems(dynamicItemsLocal)
			setSelectedPromoTiles(selectedPromoTilesLocal)
			setProducts(productsLocal)
			setActionLoader(false)
		}
	}

	const prodcutGroup = chunkProducts(products, pagePerProducts)
	let i = 0;

	return (
		<div ref={divRef} id="visualEditorGridContainer" onScroll={handleScroll} className='visualEditorGridContainer' style={{ height, userSelect: "none" }}>
			{selectedBanner && Object.keys(selectedBanner).length > 0 &&
				<div className='bannerContentContainer'>
					<div className="deleteButton" onClick={() => setSelectedBanner({})}>
						<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="18" height="18" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
							<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
							<path d="M18 6l-12 12"></path>
							<path d="M6 6l12 12"></path>
						</svg>
					</div>
					{selectedBanner.type === "image" ? (
						<img
							src={`${selectedBanner.content}`}
							className={"img-fluid"}
							title={selectedBanner.title}
							alt={selectedBanner.title}
							style={{ maxWidth: "100%", height: "auto" }}
						/>
					) : (
						<div
							className="customBannerHTML"
							dangerouslySetInnerHTML={{ __html: selectedBanner.content }}
						/>
					)}
				</div>
			}
			{products.length === 0 ?
				<div className='noResultFoundContainer'>
					<div className='noResultFoundIconWrapper'>
						{(productLoader || (props.type === "category" && categoryId) || (props.type === "search" && debouncedSearch)) ?
							<FontAwesomeIcon icon={faMagnifyingGlass} size={"3x"} color="#c9c9c9" />
							:
							<FontAwesomeIcon icon={faLayerGroup} size={"3x"} color='#c9c9c9' />
						}
					</div>
					<div>
						{(productLoader || (props.type === "category" && categoryId) || (props.type === "search" && debouncedSearch)) ?
							<>{!productLoader ? "No Result Found" : (props.type === "category" ? "Loading Category Products" : "Loading Products")}</>
							:
							<>{props.type === "category" ? "Select a Category " : "Set a Search Query "} to Create Your New Rule</>
						}
					</div>
				</div>
				:
				<div className='virutalProductWrapper'>
					<InfiniteScroll
						dataLength={productCount} // Total items rendered so far
						next={() => { setProductPage((prev) => prev + 1) }} // Fetch next page
						hasMore={hasMore} // Check if more data is available
						loader={<p>Loading...</p>} // Loading indicator
						//endMessage={<p>No more products!</p>} // End message
						scrollableTarget={"visualEditorGridContainer"}
					>
						{prodcutGroup.map((productArray, index) => {
							return (
								<SortableContext
									key={index}
									items={productArray}
									strategy={rectSortingStrategy}
								>
									<DroppableContainer>
										<div className='productListInnerWrapper' id={`prodcutGridSection${index}`} key={index}>
											<div className='gridProduct' style={{ width: "100%", "--products-per-row": rowPerProducts }}>
												{productArray.map((product, prodIndex) => {
													return (
														<DraggableItem key={prodIndex} id={product} innerStyle={typeof product.isBanner === "undefined" ? {} : {backgroundColor: "transparent", border: "none", gridArea: product.bannerSize === "Single product" ? "span 1 / span 1" : product.bannerSize === "2 Products (Horizontal)" ? "span 1 / span 2" : product.bannerSize === "2 Products (Vertical)" ? "span 2 / span 1" : product.bannerSize === "Square (2x2 Products)" ? "span 2 / span 2" : ""}}>
															{typeof product.isBanner === "undefined" ?
																<div product-id={product.id} key={prodIndex} className='mainProductContainer' style={{ display: "flex", position: "relative", width: "100%", height: "100%" }}>
																	<div id={product.id} className='selectableProductCard' style={{ width: "100%", height: "100%" }}>
																		<div className='productCard' onMouseOver={() => productMouseOver(product.id)}>
																			<div className='imageAndActionContainer'>
																				<div className='productLableContainer'>
																					<div className='badgeContainer'>
																						{promoted.indexOf(product.id) !== -1 ?
																							<div className="badgeLabelTextWrap" style={{ backgroundColor: "rgb(0, 136, 71)", color: "white" }}>Promoted</div>
																						: buried.indexOf(product.id) !== -1 ?
																							<div className="badgeLabelTextWrap" style={{ backgroundColor: "rgb(234, 12, 25)", color: "white" }}>Buried</div>
																						: typeof pinnedItems[product.id] !== "undefined" ?
																							<div className="badgeLabelTextWrap" style={{ backgroundColor: "rgb(0, 147, 229)", color: "white" }}>Pinned</div>
																						: typeof dynamicItems[product.id] !== "undefined" &&
																							<div className="badgeLabelTextWrap" style={{ backgroundColor: "rgb(16, 78, 111)", color: "white" }}>AI</div>
																						}
																					</div>
																					<div className='productPosition'>{(index * pagePerProducts) + (prodIndex + 1)}</div>
																				</div>
																				<div className='imageWrapper'>
																					<img src={product.image ? product.image :"https://storage.googleapis.com/roundclicksview/No%20Product%20Image%20Available.png"} alt={product.title} title={product.title} />
																				</div>
																				{(hoverProductId === product.id && !actionLoader) &&
																					<div className="actionBarContainer">
																						<div className="actionBarContent">
																							{typeof dynamicItems[product.id] === "undefined" &&
																								<>
																									<div className="actionItemContainer">
																										<div className="actionIconWrapper" style={{ transform: "scale(0.8)" }} onClick={(e) => { e.stopPropagation(); promptProduct(product.id) }}>
																											<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
																												<g id="surface1">
																													<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 10.394531 10.601562 C 10.199219 10.40625 10.203125 10.089844 10.398438 9.894531 L 15.648438 4.644531 C 15.84375 4.453125 16.15625 4.453125 16.351562 4.644531 L 21.601562 9.894531 C 21.796875 10.089844 21.796875 10.40625 21.601562 10.601562 C 21.410156 10.796875 21.09375 10.796875 20.898438 10.601562 L 16.5 6.207031 L 16.5 19 C 16.5 19.277344 16.277344 19.5 16 19.5 C 15.722656 19.5 15.5 19.277344 15.5 19 L 15.5 6.207031 L 11.101562 10.601562 C 10.910156 10.796875 10.589844 10.796875 10.394531 10.601562 Z M 27 18.5 C 26.722656 18.5 26.5 18.722656 26.5 19 L 26.5 26 C 26.5 26.277344 26.277344 26.5 26 26.5 L 6 26.5 C 5.722656 26.5 5.5 26.277344 5.5 26 L 5.5 19 C 5.5 18.722656 5.277344 18.5 5 18.5 C 4.722656 18.5 4.5 18.722656 4.5 19 L 4.5 26 C 4.5 26.828125 5.171875 27.5 6 27.5 L 26 27.5 C 26.828125 27.5 27.5 26.828125 27.5 26 L 27.5 19 C 27.5 18.722656 27.277344 18.5 27 18.5 Z M 27 18.5 " />
																												</g>
																											</svg>
																										</div>
																									</div>
																									<div className="actionItemContainer">
																										<div className="actionIconWrapper" style={{ transform: "scale(0.8)" }} onClick={(e) => { e.stopPropagation(); buriedProduct(product.id) }}>
																											<svg width="35" height="35" xmlns="http://www.w3.org/2000/svg">
																												<g>
																													<path d="M33.8029 5.71891L28.7806 0.697266C28.3177 0.232422 27.7068 0 27.1025 0C26.4964 0 25.8819 0.232422 25.4257 0.697266L23.4833 2.63102C22.3624 3.75992 21.7481 5.26203 21.7481 6.81461C21.7481 8.44953 22.3956 9.5957 22.8106 10.1847L14.3524 18.6469L10.6004 14.8856C10.1887 14.4699 9.63751 14.2574 9.09961 14.2574C8.55169 14.2574 8.01254 14.4659 7.59749 14.881L3.08782 19.3309C-0.232516 22.6512 0.0829161 31.3504 1.58503 32.8578C2.24113 33.5684 4.26853 34 6.618 34C9.6561 34 13.2328 33.2875 15.1114 31.4115L19.6191 26.9032C20.4492 26.0731 20.4492 24.7284 19.6191 23.8983L15.8532 20.1477L24.3134 11.6875C24.9028 12.1025 26.0566 12.75 27.6835 12.75C29.2361 12.75 30.7382 12.1357 31.8671 11.0155L33.8016 9.07309C34.7326 8.15469 34.7326 6.64062 33.8029 5.71891ZM13.6086 29.9094C11.1761 32.3498 4.68357 32.0842 3.10973 31.3869C2.39586 29.918 2.20461 23.2854 4.59591 20.8947L9.09961 16.3891L18.1176 25.4004L13.6086 29.9094ZM32.3021 7.57031L30.363 9.50937C26.8601 13.0123 21.4579 7.65863 24.9841 4.13047L26.9265 2.19672C27.0178 2.09711 27.1755 2.09711 27.2751 2.19672L32.2975 7.21902C32.4017 7.31797 32.4017 7.47734 32.3021 7.57031Z" fill="currentcolor"></path>
																												</g>
																												<defs>
																													<clipPath id="burryClip">
																														<rect width="34" height="34" fill="white" transform="translate(0.5)"></rect>
																													</clipPath>
																												</defs>
																											</svg>
																										</div>
																									</div>
																								</>
																							}
																							<div className="actionItemContainer">
																								<div className="positioningContainer">
																									<span className="actionIconOuterWrap">
																										<div className="actionIconWrapper" onClick={() => { setPositionProductId(product.id); setPositionValue((index * pagePerProducts) + (prodIndex + 1)) }} style={{ transform: "scale(0.8)" }}>
																											<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
																												<g id="surface1">
																													<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 16 30.75 C 8.5625 30.75 4.414062 29.113281 4.414062 26.363281 C 4.414062 24.773438 6.8125 23.386719 10.148438 22.625 L 10.9375 24 C 8.101562 24.5 6.273438 25.363281 6.273438 26.363281 C 6.273438 27.898438 10.960938 28.898438 16 28.898438 C 21.039062 28.898438 25.726562 27.914062 25.726562 26.363281 C 25.726562 25.363281 23.898438 24.488281 21.0625 24 L 21.851562 22.625 C 25.175781 23.398438 27.585938 24.789062 27.585938 26.363281 C 27.585938 29.050781 23.199219 30.75 16 30.75 Z M 23.699219 17.351562 C 23.425781 17.636719 17.039062 25.085938 17.039062 25.085938 C 16.773438 25.414062 16.476562 25.636719 16.164062 25.636719 C 15.835938 25.636719 15.601562 25.386719 15.363281 25.085938 C 15.363281 25.085938 8.148438 17.199219 8.023438 17.039062 C 7.898438 16.863281 7.738281 16.648438 7.601562 16.425781 C 6.648438 14.898438 6.023438 13.148438 6.023438 11.226562 C 6.023438 5.726562 10.5 1.261719 16.011719 1.261719 C 21.523438 1.261719 26 5.726562 26 11.226562 C 26 13.210938 25.414062 15.0625 24.398438 16.613281 C 24.113281 16.960938 23.851562 17.199219 23.699219 17.351562 Z M 16 3.101562 C 11.488281 3.101562 7.8125 6.761719 7.8125 11.261719 C 7.8125 12.75 8.300781 14.085938 9.050781 15.175781 C 9.300781 15.5625 10.0625 16.476562 10.0625 16.476562 L 16.210938 23.324219 L 21.824219 16.664062 C 21.824219 16.664062 22.125 16.3125 22.476562 15.800781 C 23.375 14.488281 24.175781 13.0625 24.175781 11.261719 C 24.1875 6.75 20.523438 3.101562 16 3.101562 Z M 16 15.0625 C 13.875 15.0625 12.148438 13.335938 12.148438 11.210938 C 12.148438 9.085938 13.875 7.375 16 7.375 C 18.125 7.375 19.851562 9.101562 19.851562 11.226562 C 19.851562 13.335938 18.125 15.0625 16 15.0625 Z M 16 9.226562 C 14.898438 9.226562 14 10.125 14 11.210938 C 14 12.3125 14.898438 13.199219 16 13.199219 C 17.101562 13.199219 18 12.300781 18 11.210938 C 18 10.113281 17.101562 9.226562 16 9.226562 Z M 16 9.226562 " />
																												</g>
																											</svg>
																										</div>
																									</span>
																									<span className={`actionInputContainer ${positionProductId === product.id ? "enableInput" : ""}`}>
																										<div className="actionInputInnerWrap">
																											<input type="num" placeholder="" className="actionInput" value={positionValue} disabled={positionChange} onChange={(e) => { setPositionTrigger(true); setPositionValue(e.target.value) }} />
																										</div>
																									</span>
																								</div>
																							</div>
																							{typeof dynamicItems[product.id] === "undefined" &&
																								<>
																									{(typeof pinnedItems[product.id] !== "undefined" || promoted.indexOf(product.id) !== -1 || buried.indexOf(product.id) !== -1) &&
																										<div className="actionItemContainer">
																											<div className="actionIconWrapper" onClick={(e) => { e.stopPropagation(); restoreProduct(product.id) }}>
																												<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentcolor">
																													<path d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z" />
																												</svg>
																											</div>
																										</div>
																									}
																									<div className="actionItemContainer">
																										<div className="actionIconWrapper" style={{ transform: "scale(0.8)" }} onClick={(e) => { e.stopPropagation(); hiddenProduct(product.id) }}>
																											{/* <FontAwesomeIcon icon={faEyeSlash} size='1x' /> */}
																											<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="32px" height="32px" viewBox="0 0 32 32" version="1.1">
																												<g id="surface1">
																													<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 21.464844 17.734375 L 19.535156 15.800781 C 19.734375 14.753906 19.433594 13.777344 18.632812 12.867188 C 17.832031 11.957031 16.800781 11.601562 15.535156 11.800781 L 13.601562 9.867188 C 13.976562 9.6875 14.359375 9.554688 14.75 9.464844 C 15.140625 9.378906 15.554688 9.332031 16 9.332031 C 17.667969 9.332031 19.082031 9.917969 20.25 11.082031 C 21.417969 12.25 22 13.667969 22 15.332031 C 22 15.777344 21.957031 16.195312 21.867188 16.582031 C 21.777344 16.972656 21.644531 17.355469 21.464844 17.734375 Z M 25.734375 21.933594 L 23.800781 20.066406 C 24.644531 19.421875 25.394531 18.714844 26.050781 17.949219 C 26.707031 17.183594 27.265625 16.3125 27.734375 15.332031 C 26.621094 13.089844 25.027344 11.304688 22.949219 9.984375 C 20.871094 8.660156 18.554688 8 16 8 C 15.355469 8 14.722656 8.042969 14.101562 8.132812 C 13.476562 8.222656 12.867188 8.355469 12.265625 8.535156 L 10.199219 6.464844 C 11.109375 6.089844 12.042969 5.804688 13 5.617188 C 13.957031 5.429688 14.957031 5.332031 16 5.332031 C 19.355469 5.332031 22.34375 6.261719 24.964844 8.117188 C 27.589844 9.972656 29.488281 12.378906 30.667969 15.332031 C 30.15625 16.644531 29.484375 17.859375 28.648438 18.984375 C 27.816406 20.105469 26.84375 21.089844 25.734375 21.933594 Z M 26.398438 30.132812 L 20.800781 24.601562 C 20.023438 24.84375 19.238281 25.027344 18.449219 25.148438 C 17.660156 25.273438 16.84375 25.332031 16 25.332031 C 12.644531 25.332031 9.65625 24.40625 7.035156 22.550781 C 4.410156 20.695312 2.511719 18.289062 1.332031 15.332031 C 1.800781 14.15625 2.390625 13.0625 3.101562 12.050781 C 3.8125 11.039062 4.621094 10.132812 5.535156 9.332031 L 1.867188 5.601562 L 3.734375 3.734375 L 28.265625 28.265625 Z M 7.398438 11.199219 C 6.753906 11.777344 6.167969 12.410156 5.632812 13.101562 C 5.101562 13.789062 4.644531 14.535156 4.265625 15.332031 C 5.378906 17.578125 6.972656 19.359375 9.050781 20.683594 C 11.128906 22.003906 13.445312 22.667969 16 22.667969 C 16.445312 22.667969 16.878906 22.640625 17.300781 22.582031 C 17.722656 22.527344 18.15625 22.464844 18.601562 22.398438 L 17.398438 21.132812 C 17.15625 21.199219 16.921875 21.25 16.699219 21.285156 C 16.476562 21.316406 16.246094 21.332031 16 21.332031 C 14.332031 21.332031 12.917969 20.75 11.75 19.582031 C 10.582031 18.417969 10 17 10 15.332031 C 10 15.089844 10.015625 14.855469 10.050781 14.632812 C 10.082031 14.410156 10.132812 14.179688 10.199219 13.933594 Z M 18.035156 14.300781 Z M 13 16.800781 Z M 13 16.800781 " />
																												</g>
																											</svg>
																										</div>
																									</div>
																									{(typeof pinnedItems[product.id] === "undefined" && promoted.indexOf(product.id) === -1 && buried.indexOf(product.id) === -1) &&
																										<div className="actionItemContainer">
																											<div className="actionIconWrapper" style={{ transform: "rotate(35deg)" }} onClick={(e) => { e.stopPropagation(); pinProduct(product.id) }}>
																												<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="28px" fill="currentcolor">
																													<path d="m636-458.67 84 78V-314H513.33v240.67L480-40l-33.33-33.33V-314H240v-66.67l80-78v-314.66h-46.67V-840h409.34v66.67H636v314.66Zm-304 78h292l-54.67-52v-340.66H386.67v340.66l-54.67 52Zm146 0Z" />
																												</svg>
																											</div>
																										</div>
																									}
																								</>
																							}
																						</div>
																					</div>
																				}
																			</div>
																			<div className='productInfoContainer'>
																				<div className='productTitleWrapper'>
																					{product.title}
																				</div>
																				<div className='productSkuWrapper'>{product.sku}</div>
																				<div className='productCardFooter'>
																					<div className='productPriceContainer gap-3'>
																						{formatPrice(product)}
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															:
																<div product-id={product.id} key={prodIndex} className='bannerOuterContainer' style={{ display: "flex", position: "relative", width: "100%", height: "100%", gridArea: product.bannerSize === "Single product" ? "span 1 / span 1" : product.bannerSize === "2 Products (Horizontal)" ? "span 1 / span 2" : product.bannerSize === "2 Products (Vertical)" ? "span 2 / span 1" : product.bannerSize === "Square (2x2 Products)" ? "span 2 / span 2" : ""  }}>
																	<div className='promoTileContainer'>
																		<div className="promoTileImageContainer" style={{width: "100%", height: "100%"}}>
																			<img src={product.image} alt={product.title} className="promoTileImage" />
																			<div className='promoDeleteItem' onClick={() => deletePromoTile(prodIndex, product.id)}>
																				<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="18" height="18" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
																					<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
																					<path d="M18 6l-12 12"></path>
																					<path d="M6 6l12 12"></path>
																				</svg>
																			</div>
																		</div>
																	</div>
																</div>
															}
														</DraggableItem>
													)
												})}
											</div>
											{((((index + 1) * pagePerProducts) < productCount) && (index + 1 !== prodcutGroup.length)) &&
												<div className='pageSeperatorWrap'>Page {index + 2}</div>
											}
										</div>
									</DroppableContainer>
								</SortableContext>
							)
						})}
					</InfiniteScroll>
					{showTopButton && (
						<button
							onClick={scrollToTop}
							style={{
								position: "fixed",
								bottom: "20px",
								right: "20px",
								padding: "8px",
								backgroundColor: "rgba(0, 0, 0, 0.7)",
								color: "#fff",
								border: "none",
								cursor: "pointer",
								fontSize: "12px",
								borderRadius: "5px",
								lineHeight: 1
							}}
						>
							Scroll to Top
						</button>
					)}
				</div>
			}

		</div>
	)
}

export default ProductListing